// extracted by mini-css-extract-plugin
module.exports = {"btn-container":"social_buttons_btn-container__ZV4wC","button":"social_buttons_button__kYUz_"};